import { BaseProduct, ProductBuilderMachineContext } from '../types';

type GetLining = (context: ProductBuilderMachineContext) => string[];
type ProductHasLiningOption = (product: BaseProduct) => boolean;
type GetVariantOptionKeyForLining = (product: BaseProduct) => LiningKey | null;

type LiningKey = 'option1' | 'option2' | 'option3';
type ProductHasVariantWithLining = (
  lining: string,
) => (product: BaseProduct) => boolean;

export const productHasLiningOption: ProductHasLiningOption = product =>
  product.options.includes('Lining') || product.options.includes('Transparency');

export const getVariantOptionKeyForLining: GetVariantOptionKeyForLining = product => {
  const liningIndex = product.options.findIndex(option => option === 'Lining' || option === 'Transparency');
  if (liningIndex === -1) return null;

  return `option${liningIndex + 1}` as LiningKey;
};

export const getLining: GetLining = context => {
  const { products } = context;

  const liningKey =
    products.length > 0 ? getVariantOptionKeyForLining(products[0]) : null;
  if (liningKey === null) return [];

  return Array.from(
    new Set(
      products
        .map(({ variants }) =>
          variants.map(variant => {
            return variant[liningKey] as string;
          }),
        )
        .flat(),
    ),
  );
};

export const productHasVariantWithLining: ProductHasVariantWithLining = lining => product => {
  const optionKey = getVariantOptionKeyForLining(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === lining);
};
